<header class="client-mobile-header">
  <button type="button" class="client-mobile-header__icon-btn" [attr.aria-label]="'mobile.header.openMenu' | translate">
    <ion-icon name="menu-outline"></ion-icon>
  </button>
  <a routerLink="/home" class="client-mobile-header__brand">
    <span class="client-mobile-header__logo">M</span>
    <span class="client-mobile-header__brand-name">{{ 'common.brandName' | translate }}</span>
  </a>
  <a routerLink="/notifications" class="client-mobile-header__icon-btn client-mobile-header__icon-btn--notify" [attr.aria-label]="'mobile.header.notifications' | translate">
    <ion-icon name="notifications-outline"></ion-icon>
    <span class="client-mobile-header__notify-dot" aria-hidden="true"></span>
  </a>
</header>
